/* eslint-disable @typescript-eslint/no-restricted-imports */
import * as proceduralTexture from "procedural-textures/legacy/legacy-marble";
export { proceduralTexture };
export default proceduralTexture;
